import React from 'react';
import TenantModuleGate from './TenantModuleGate';

interface FashionModuleGateProps {
  children: React.ReactNode;
}

const FashionModuleGate: React.FC<FashionModuleGateProps> = ({ children }) => (
  <TenantModuleGate moduleKey="fashion">{children}</TenantModuleGate>
);

export default FashionModuleGate;
